<template>
  <div>
    <vue-final-modal
      v-model="showModal"
      classes="modal-container"
      content-class="modal-dialog modal-content"
      :max-width="600"
      :max-height="500"
      :z-index="9999"
    >
      <button class="modal__close" @click="showModal = false">
        <i class="fas fa-times"></i>
      </button>
      <span class="modal__title">{{ title }}</span>
      <div class="modal__content">
        <input-module
          type="text"
          title="Имя сотрудника"
          v-model="contact.name"
        />
        <input-module type="phone" title="Телефон" v-model="contact.value" />
      </div>
      <div class="modal__footer">
        <button class="btn btn-primary" @click="saveContact">Сохранить</button>
      </div>
    </vue-final-modal>
  </div>
</template>


<script>
export default {
  data() {
    return {
      showModal: false,
      title: "Новый контакт",
      contact_i: -1,
      contact: {
        value: "",
        name: "",
      },
    };
  },
  methods: {
    openModal({ contact, i } = {}) {
      if (contact) {
        this.title = "Редактирование контакта";
        this.contact.value = contact.value.toString();
        this.contact.name = contact.name.toString();
        this.contact_i = Number(i);
      } else {
        this.title = "Новый контакт";
        this.contact.value = "";
        this.contact.name = "";
        this.contact_i = -1;
      }
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    saveContact() {
      this.$emit("CreateOrUpdateClient", {
        contact: {
          name: this.contact.name.toString(),
          value: this.contact.value.toString(),
        },
        i: Number(this.contact_i),
      });
      this.closeModal();
    },
  },
};
</script>


<style lang="scss" scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}
::v-deep .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #272727;
  border-radius: 0.25rem;
  background: #272727;
}
.modal__title {
  margin: 0 2rem 0 0;
  font-size: 1.5rem;
  font-weight: 700;
}
.modal__content {
  flex-grow: 1;
  overflow-y: auto;
}
.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: unset;
  outline: unset;
  border: unset;
  opacity: 0.8;
  cursor: pointer;
  color: white;
  &:hover {
    opacity: 1;
  }
}

.modal__footer {
  text-align: right;
  margin-top: 50px;
}

.remove_item {
  border: unset;
  background: unset;
  outline: unset;
  cursor: pointer;
  color: black;
  opacity: 0.6;
  font-size: 10px;
  position: relative;
  &:hover {
    opacity: 1;
    color: red;
  }
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
</style>

<style lang="scss" scoped>
</style>